import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../components/general/Image';
import Button from '../../components/general/Button';
import { CaseStudy1, CaseStudy2, CaseStudy3, CaseStudy4 } from '../../constants/ImagePaths';
import { CaseStudyBackground } from '../../constants/ImagePaths';
import { ArrowUpRight } from '../../components/common/Icons';

const CaseStudies = () => {
  const backgroundStyle = {
    backgroundImage: `url(${CaseStudyBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'initial',
    backgroundRepeat: 'no-repeat',
  }

  const navigate = useNavigate()

  return (
    <section style={backgroundStyle}>
      <div className="--layout-padding max-width grid grid-cols-2 items-center gap-4 !py-[50px] md:grid-cols-3 lg:flex lg:gap-0 lg:justify-between">      
        <Image className="w-[130px]" src={CaseStudy1} alt=""/>
        <Image className="w-[200px]" src={CaseStudy2} alt=""/>
        <Image className="w-[200px]" src={CaseStudy3} alt=""/>
        <Image className="w-[200px]" src={CaseStudy4} alt=""/>
        <Button className="btn btn-outline-white col-span-2 lg:col-span-1 border border-white rounded lg:w-[200px] lg:h-[50px] text-black" href={"#"}>
          <div className="flex items-center justify-center gap-2">
            <span>Our Case studies</span> 
            <ArrowUpRight className="w-4 h-4 text-black" />
          </div>
        </Button>
      </div>
    </section>
  );
};

export default CaseStudies;